import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThumbsUpIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ThumbsUp",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.14 12.26h1.07c1.18 0 2.14.96 2.14 2.14v12.84c0 1.18-.96 2.14-2.14 2.14H4.14c-1.18 0-2.14-.96-2.14-2.14V14.4c0-1.18.96-2.14 2.14-2.14m11.77-7.5c.59 0 1.07.48 1.07 1.07v8.56h8.83c1.18 0 2.14.96 2.14 2.14a2.142 2.142 0 0 1-2.88 2.01h.01v.17c1.02.18 1.79 1.06 1.79 2.12 0 1.19-.96 2.15-2.15 2.15-.13 0-.25-.01-.38-.03h.01v.16a2.14 2.14 0 0 1-.71 4.12H12.7c-.59 0-1.07-.48-1.07-1.07V14.39l1.96-8.79c.11-.48.54-.83 1.04-.83h1.28Zm0-2.14h-1.28c-1.53 0-2.8 1.07-3.13 2.49v.02l-2 8.79c0 .07-.01.15-.01.23s0 .16.01.24 0 11.76 0 11.76c0 1.77 1.44 3.21 3.21 3.21h10.93a4.28 4.28 0 0 0 4.23-4.28c0-.45-.07-.88-.2-1.28v.03c.79-.77 1.27-1.85 1.27-3.03 0-.45-.07-.88-.19-1.28v.03c.78-.77 1.26-1.85 1.26-3.03a4.28 4.28 0 0 0-4.23-4.28h-6.66V5.82c0-1.77-1.44-3.21-3.21-3.21Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.29 19.86H22a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 0 0-2.28h-6.86a1.14 1.14 0 1 1 0-2.28h6.86c1.89 0 3.43 1.54 3.43 3.43s-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22 29h-3.43a1.14 1.14 0 1 1 0-2.28H22a1.14 1.14 0 1 0 0-2.28 1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 0 0-2.28H22a1.14 1.14 0 1 1 0-2.28h2.29c1.89 0 3.43 1.54 3.43 3.43 0 1.58-1.07 2.91-2.53 3.31.16.39.24.82.24 1.26 0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.49 29h-3.43c-3.15 0-5.71-2.56-5.71-5.71v-8.65c0-.99.26-1.97.75-2.83l4.21-7.37c.2-.36.58-.58.99-.58 1.46 0 2.8.72 3.6 1.94.8 1.21.94 2.74.37 4.07L17.93 13h3.98a1.14 1.14 0 1 1 0 2.28H16.2c-.38 0-.74-.19-.95-.51s-.25-.73-.1-1.08l2.02-4.72c.27-.64.21-1.34-.17-1.91-.26-.4-.64-.69-1.08-.82l-3.83 6.7c-.29.52-.45 1.11-.45 1.7v8.65c0 1.89 1.54 3.43 3.43 3.43h3.43a1.14 1.14 0 1 1 0 2.28ZM6 29c-.63 0-1.14-.51-1.14-1.14V14.15a1.14 1.14 0 1 1 2.28 0v13.71C7.14 28.49 6.63 29 6 29"
      })]
    })
  }));
};
ThumbsUpIcon.displayName = 'ThumbsUpIcon';